import type { ILineItemForm } from '@/Interfaces/CampaignManagement/LineItem.interface';
import LineItemSummaryService from '@/Services/CampaignManagement/LineItemSummary.service';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import InfoTable from './InfoTable';

const AudienceInfo = memo(() => {
  const { getValues } = useFormContext<ILineItemForm>();

  const rows = LineItemSummaryService.getAudienceInfo(getValues());

  if (!rows?.length) {
    return null;
  }

  return <InfoTable caption='Audience' rows={rows} />;
});

export default AudienceInfo;
